interface Props {
	optionData: { key: string; name: string }[];
	value: string;
	onChange: (key: string) => void;
	label?: string;
	disabled?: boolean;
	/** Fill the available width on small screens (natural width from md and up) */
	stretchOnMobile?: boolean;
}

const ToggleSwitch = ({ value, optionData, onChange, label, disabled, stretchOnMobile = false }: Props) => {
	return (
		<div className={`flex flex-row items-center ${stretchOnMobile ? "w-full md:w-auto" : ""}`}>
			{label && (
				<span className="font-medium text-sm mr-2 hidden lg:inline" style={{ color: "#999999" }}>
					{`${label}: `}
				</span>
			)}
			<div
				className={`h-11 rounded-xl flex flex-row items-center justify-between p-1.5 ${
					stretchOnMobile ? "flex-1 min-w-0 gap-1 md:flex-none md:gap-2" : "gap-2"
				}`}
				style={{ backgroundColor: "#EDEFF3" }}
			>
				{optionData.map(({ key, name }) => {
					const isSelected = key === value;
					return (
						<button
							key={key}
							type="button"
							style={{
								backgroundColor: isSelected ? "#353535" : "transparent",
								color: isSelected ? "#FFFFFF" : "#9a9a9a",
							}}
							className={`
								font-semibold h-8.5 rounded-[12px]
								flex items-center justify-center
								whitespace-nowrap
								${
									stretchOnMobile
										? "flex-auto min-w-0 !px-1 !text-[11px] min-[360px]:!px-1.5 min-[360px]:!text-xs sm:!px-3 sm:!text-sm md:flex-none md:min-w-25"
										: "!px-3 !text-sm min-w-25"
								}
								transition-all duration-200
								${isSelected ? "shadow-sm !bg-black" : ""}
								${disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer hover:opacity-80"}
							`}
							onClick={() => {
								if (!disabled) {
									onChange(key);
								}
							}}
							disabled={disabled}
						>
							<span className="min-w-0 truncate">{name}</span>
						</button>
					);
				})}
			</div>
		</div>
	);
};

export default ToggleSwitch;
